import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        tasklist: '='
    },
    template: `
<div class="modal-header">
    <button type="button" class="close" ng-click="vm.uibModalInstance.close()"></button>
    <h2>{{ 'tasklist.Mark as complete' | translate}}</h2>
</div>
<div class="modal-body">
    <div class="form">
        <div class="row">
            <span class="label">{{ 'tasklist.Employee' | translate }}</span>
            <div class="items"><span class="text">{{ vm.tasklist.user.displayName }}</span></div>
        </div>
        <div class="row">
            <span class="label">{{ 'tasklist.Tasklist template' | translate }}</span>
            <div class="items">
                <span class="text">{{ vm.tasklist.tasklistTemplate.name }}</span>
            </div>
        </div>
        <h2>{{ 'tasklist.Tasks' | translate }}</h2>
        <ul class="items06 type02">
            <li ng-repeat="task in vm.tasklist.tasklistTasks">
                <form class="form">
                    <div class="row">
                        <span class="label">{{ 'tasklist.Task' | translate }}</span>
                        <div class="items">
                            <span class="text">{{ task.name }}</span>
                        </div>
                    </div>
                    <div class="row row-html">
                        <span class="label">{{ 'tasklist.Description' | translate }}</span>
                        <div class="items" ng-bind-html="task.description" ng-if="task.description"></div>
                        <div class="items" ng-if="!task.description"><span class="text">-</span></div>
                    </div>
                    <div class="row">
                        <span class="label">{{ 'tasklist.Deadline' | translate }}</span>
                        <div class="items">
                            <span class="text">{{ vm.MomentService.formatDate(task.deadline) }}</span>
                        </div>
                    </div>
                    <form-row error="vm.form.errors.tasklistTasks[$index].comment">
                        <span class="label">{{ 'tasklist.Comment' | translate }}</span>
                        <div class="items">
                            <textarea class="form-control" ng-model="vm.form.model.tasklistTasks[$index].comment"></textarea>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row ng-if="task.fileId" error="vm.form.errors.tasklistTasks[$index].attachment">
                        <span class="label">{{ 'tasklist.Attachment' | translate }}</span>
                        <div class="items"><span class="text"><a ng-click="vm.downloadFile(task.fileId)">{{ task.file.filename }}</a></span></div>
                    </form-row>
                    <div class="row">
                        <span class="label">{{ 'tasklist.Completed' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox" name="switch" ng-checked="vm.isCompleteStatus(task)" ng-click="vm.updateStatus(task)">
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                            <p ng-if="task.completedBy" class="desc">{{ vm.getCompletorLabel(task) }}</p>
                        </div>
                    </div>
                </form>
            </li>
        </ul>
    </div>
</div>
<div class="modal-footer">
    <ul class="actions01">
        <li class="primary">
            <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
        </li>
        <li>
            <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.close()">{{ 'general.Cancel' | translate }}</button>
        </li>
    </ul>
</div>

    `
})
export default class {
    constructor ($translate, lodash, toastr, FormFactory, MomentService, TasklistTaskResource, TASKLIST_TASK_STATUS_ENUM,
        $window, AuthResource) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.FormFactory = FormFactory;
        this.MomentService = MomentService;
        this.TasklistTaskResource = TasklistTaskResource;
        this.TASKLIST_TASK_STATUS_ENUM = TASKLIST_TASK_STATUS_ENUM;
        this.$window = $window;
        this.AuthResource = AuthResource;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.tasklist);
    }

    downloadFile (id) {
        this.AuthResource
        .requestTacToken().$promise
        .then(({ token }) => {
            const url = `${SEED_CORE.ENV.API_URL}tasklist/template/task-attachment-export?tacToken=${token}&id=${id}`;
            this.$window.open(url);
        });
    }

    isCompleteStatus (task) {
        return task.status === this.TASKLIST_TASK_STATUS_ENUM.KEYS.COMPLETED;
    }

    getCompletorLabel (task) {
        const completor = task.completor.displayName;
        const completedAt = task.completedAt + 3 * 60 * 60;
        const date = this.MomentService.formatTimeStamp(completedAt, 'DD.MM.YYYY HH:mm', true);
        return this.$translate.instant('tasklist.Completed at {date} by: {completor}', {
            date, completor
        });
    }

    save () {
        this.form.save({ expand: 'tasklistTasks.file,tasklistTemplate,user,nextTask,tasklistTasks.completor' }).then((tasklist) => {
            this.tasklist = tasklist;
            this.toastr.success(this.$translate.instant('general.Changes saved'));
            this.uibModalInstance.close();
        });
    }

    updateStatus (task) {
        let status = this.TASKLIST_TASK_STATUS_ENUM.KEYS.COMPLETED;
        if (this.isCompleteStatus(task)) {
            status = this.TASKLIST_TASK_STATUS_ENUM.KEYS.INCOMPLETE;
        }
        this.TasklistTaskResource.update({ id: task.id }, { status }).$promise.then(() => {
            task.status = status;
            this.toastr.success(this.$translate.instant('general.Changes saved'));

            // update status in form model as well to avoid reverting status when "save" is hit
            this.form.model.tasklistTasks.forEach((tasklistTask) => {
                if (tasklistTask.id === task.id) {
                    tasklistTask.status = status;
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/tasklist/markComplete/index.js